import { render, staticRenderFns } from "./MonitoringTrip.vue?vue&type=template&id=2c859744&scoped=true&"
import script from "./MonitoringTrip.vue?vue&type=script&lang=js&"
export * from "./MonitoringTrip.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringTrip.vue?vue&type=style&index=0&id=2c859744&prod&lang=scss&"
import style1 from "./MonitoringTrip.vue?vue&type=style&index=1&id=2c859744&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c859744",
  null
  
)

export default component.exports